import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../settings/index';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';

const api = new Api('agencies/:id/agents');

function* loadData({ payload }) {
  try {
    const { id, filter, page = 1, pageSize = tableConfig.pageSize } = payload;
    const search = { page, pageSize, filter };

    const result = yield call(sendRequest, api.load, { search, id }, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadData)]);
}
